// Generated from Spot's `required_filter_groups` — do not edit.

import type {FilterDefinitionMapping} from '../../boot/hooks/useApi'
import type {Iri} from '../Api'

export type SpotCollectionFilterGroups
  = | {
    readonly slug: string | string[]
  }
  | {
    readonly id: Iri | Iri[]
  }
  | {
    readonly name: string
    readonly active?: boolean | boolean[]
    readonly visible?: boolean | boolean[]
  }

export const spotCollectionFilterMapping: FilterDefinitionMapping<SpotCollectionFilterGroups> = {
  slug: 'slug',
  id: 'id',
  name: 'name',
  active: 'active',
  visible: 'visible',
}

export type SpotCollectionSort = 'name'
